import {useEffect, useRef} from 'react';

export const useWindowEvent = (event, callback) => {
  useEffect( () => {
    window.addEventListener( event, callback );
    return () => window.removeEventListener( event, callback );
  }, [ event, callback ] )
}

export const useDocumentEvent = (event, callback) => {
  useEffect( () => {
    document.addEventListener( event, callback );
    return () => document.removeEventListener( event, callback );
  }, [ event, callback ] )
}

export const useAnimationFrame = (callback) => {
  useEffect( () => {
    let req = 0;

    const raf = () => {
      callback();
      req = window.requestAnimationFrame( raf );
    }

    req = window.requestAnimationFrame( raf );

    return () => window.cancelAnimationFrame( req );
  }, [ callback ] )
}



export const useGlobalScroll = callback => {
  return useWindowEvent( "scroll", callback );
}

export const useGlobalResize = callback => {
  return useWindowEvent( "resize", callback );
}


export const useRefEvent = (ref, event, callback) => {
  useEffect( () => {
    const current = ref.current;
    current.addEventListener( event, callback );
    return () => current.removeEventListener( event, callback );
  }, [ ref, event, callback ] )
}


export const useLoseFocus = (ref, callback) =>
{
  useEffect( () => {
    const onMouseDown = ({ target }) => {
      if( !ref.current )
        return;

      if( !ref.current.contains(target) )
        callback();
    }

    const onKeyPress = ({ key }) => {
      if( !ref.current )
        return;

      if( key === 'Escape' )
        callback();
    }

    window.addEventListener( 'mousedown', onMouseDown );
    window.addEventListener( 'keydown', onKeyPress );

    return () => {
      window.removeEventListener( 'mousedown', onMouseDown );
      window.removeEventListener( 'keydown', onKeyPress );
    }
  }, [ref, callback])
}


export const usePortal = (id) => {
  const rootElemRef = useRef(document.createElement("div"));


  useEffect(() => {
    const parentEl = document.getElementById(id);
    parentEl.appendChild(rootElemRef.current);

    return () => rootElemRef.current.remove();
  }, []);

  return rootElemRef.current;
}
